import type { Types } from '@ohif/core';
import React from 'react';
import SRViewportWrapper from './components/SRViewport';

export default function getViewportModule({
  servicesManager,
  extensionManager,
}: Types.Extensions.ExtensionParams) {
  const ExtendedSRViewportWrapper = (props: withAppTypes) => (
    <SRViewportWrapper
      servicesManager={servicesManager}
      extensionManager={extensionManager}
      {...props}
    />
  );

  return [{ name: 'dicom-sr', component: ExtendedSRViewportWrapper }];
}
